import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { toast } from 'sonner';
import { api } from '../../utils/api';

/* ─── Admin → Affiliate Applications tab ─── */
export const AdminAffiliatesTab = ({ affiliateApps, setAffiliateApps }) => {
  return (
          <div className="lm-enter">
            <h2 className="text-2xl font-bold mb-6" data-testid="affiliates-heading">Affiliate Applications</h2>
            {affiliateApps && (
              <>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
                  <Card className="p-4 text-center">
                    <p className="text-2xl font-bold">{affiliateApps.stats.total}</p>
                    <p className="text-xs text-muted-foreground">Total</p>
                  </Card>
                  <Card className="p-4 text-center">
                    <p className="text-2xl font-bold text-orange-500">{affiliateApps.stats.pending}</p>
                    <p className="text-xs text-muted-foreground">Pending</p>
                  </Card>
                  <Card className="p-4 text-center">
                    <p className="text-2xl font-bold text-green-500">{affiliateApps.stats.approved}</p>
                    <p className="text-xs text-muted-foreground">Approved</p>
                  </Card>
                  <Card className="p-4 text-center">
                    <p className="text-2xl font-bold text-destructive">{affiliateApps.stats.rejected}</p>
                    <p className="text-xs text-muted-foreground">Rejected</p>
                  </Card>
                </div>
                <div className="space-y-3">
                  {affiliateApps.applications.map(app => (
                    <Card key={app.id} className={`p-5 ${app.status === 'pending' ? 'border-orange-500/30' : ''}`} data-testid={`affiliate-app-${app.id}`}>
                      <div className="flex flex-col sm:flex-row justify-between gap-4">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-1">
                            <p className="font-semibold text-lg">{app.name}</p>
                            <Badge className={app.status === 'approved' ? 'bg-green-100 text-green-700' : app.status === 'rejected' ? 'bg-red-100 text-red-700' : 'bg-orange-100 text-orange-700'}>
                              {app.status}
                            </Badge>
                            {app.referral_count > 0 && (
                              <Badge variant="secondary">{app.referral_count} referrals</Badge>
                            )}
                          </div>
                          <p className="text-sm text-muted-foreground">{app.email}</p>
                          <p className="text-sm mt-2"><strong>Followers:</strong> {app.follower_count || 'Not specified'}</p>
                          <div className="mt-2">
                            <p className="text-sm font-medium">Social links:</p>
                            <p className="text-sm text-muted-foreground whitespace-pre-wrap">{app.social_links}</p>
                          </div>
                          {app.reason && (
                            <div className="mt-2">
                              <p className="text-sm font-medium">Why:</p>
                              <p className="text-sm text-muted-foreground">{app.reason}</p>
                            </div>
                          )}
                        </div>
                        {app.status === 'pending' && (
                          <div className="flex sm:flex-col gap-2 flex-shrink-0">
                            <Button size="sm" onClick={async () => {
                              await api.adminApproveAffiliate(app.id);
                              api.adminGetAffiliates().then(setAffiliateApps);
                              toast.success(`${app.name} approved!`);
                            }} data-testid={`approve-${app.id}`}>
                              Approve
                            </Button>
                            <Button size="sm" variant="destructive" onClick={async () => {
                              await api.adminRejectAffiliate(app.id);
                              api.adminGetAffiliates().then(setAffiliateApps);
                              toast.success(`${app.name} rejected`);
                            }} data-testid={`reject-${app.id}`}>
                              Reject
                            </Button>
                          </div>
                        )}
                      </div>
                    </Card>
                  ))}
                  {affiliateApps.applications.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">No affiliate applications yet</div>
                  )}
                </div>
              </>
            )}
          </div>
  );
};
